import { Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import React, { useRef } from 'react';
import { Shadows } from 'theme';
import { makeStyles } from 'tss-react/mui';
import { HoveredHighlightState } from './custom-quill-editor';

export interface HighlightContent {
  text: string;
  categories: string;
}

interface Props {
  hoverHighlightState: HoveredHighlightState;
}

const HighlightTooltip: React.FC<Props> = ({ hoverHighlightState }) => {
  const { classes } = useStyles();
  const popperRef = useRef<any>(null);

  return (
    <Tooltip
      classes={{ tooltip: classes.tooltip }}
      open={hoverHighlightState.isOpen}
      PopperProps={{
        popperRef,
        anchorEl: hoverHighlightState.element,
      }}
      title={
        <>
          <Typography className={classes.highlightToolTipText}>{(hoverHighlightState.content as HighlightContent)?.text}</Typography>
        </>
      }
    >
      <span />
    </Tooltip>
  );
};

const useStyles = makeStyles()((theme) => ({
  highlightToolTipText: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.text.primary,
  },
  tooltip: {
    borderRadius: 0,
    color: 'black',
    background: 'white',
    boxShadow: Shadows.GREY_SHADOW_LIGHTER,
    maxWidth: '275px',
    padding: '8px',
  },
}));

export default HighlightTooltip;
